import React, { useMemo } from 'react';
import KanbanColumn from './KanbanColumn';
import OperationCard from '../OperationCard';

/**
 * Columna "Operaciones en curso" — agrupa solicitudes en estado `Enviada`.
 *
 * Archivo independiente para que se pueda modificar sin tocar
 * las otras 3 columnas (Cotizaciones, Finalizadas, Rechazadas).
 */
const EnCursoColumn = ({ items = [], onAction, loading = false, headerExtra, actionsMode = 'full' }) => {
  const renderItem = useMemo(
    () => (r) => <OperationCard r={r} variant="en-curso" onAction={onAction} actionsMode={actionsMode} />,
    [onAction, actionsMode],
  );

  return (
    <KanbanColumn
      id="en-curso"
      title="Operaciones en curso"
      accent="border-t-blue-500"
      badge="bg-blue-100 text-blue-800 border-blue-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin operaciones en curso"
      headerExtra={headerExtra}
    />
  );
};

export default EnCursoColumn;
